export const PAGE_SIZE = 60;

export const FACET_TYPES = {
    PAGE: 'page',
    SEARCH: 'searchTerm',
    STYLE: 'style',
    ROOM: 'room',
    PROJECT: 'project',
    CREATOR: 'creator',
} as const;

export const FACET_TYPE_LIST = Object.values(FACET_TYPES);

// photo facets that may have multiple values
export const PHOTO_FACET_TYPE_LIST = [
    FACET_TYPES.STYLE,
    FACET_TYPES.ROOM,
    FACET_TYPES.PROJECT,
    FACET_TYPES.CREATOR,
] as const;

export const RELAY_FACET_PHOTO_FACET_TYPE_MAP = {
    imageStyleFacet: FACET_TYPES.STYLE,
    imageRoomTypeFacet: FACET_TYPES.ROOM,
    designProjectTypeFacet: FACET_TYPES.PROJECT,
    imageCreatorFacets: FACET_TYPES.CREATOR,
} as const;
